import React from "react";

const CoreComponent23 = ({ rounded }) => {
  return (
    <div>
      <div className="row mt-60 mart d-flex  justify-content-center ">
        {rounded.map((val, i) => (
          <div key={i} className="col-lg-4 col-md-6 marb mb-60 text-center transform-rotate ">
            <div className="border-card p-3  h-100" style={{ height: '' }}>
              <img src={val.icon} alt="" className="icon-logo" />
              <div>
                <h3 className="h3-heading lh-base fs-4 mb-2 mt-2">{val.title}</h3>
                <p className="fs-6 h3-para ">{val.desc}</p>
              </div>



              
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreComponent23;
